export default __webpack_public_path__ + "static/media/icon-search.49df8a17.svg";